export default "__VITE_ASSET__Wo_l_6lM__"